module.exports = __webpack_public_path__ + "img/pansheng-banner.b55209e4.png";